import c1 from "../assets/c1.jpeg";
import c2 from "../assets/c2.jpeg";
import c3 from "../assets/c3.jpeg";
import c4 from "../assets/c4.jpeg";
import c5 from "../assets/c5.jpeg";
import c6 from "../assets/c6.jpeg";
import c7 from "../assets/c7.jpeg";
import c8 from "../assets/c8.jpeg";
import c9 from "../assets/c9.jpeg";
import c10 from "../assets/c10.jpeg";
import c11 from "../assets/c11.jpeg";
import c12 from "../assets/c12.jpeg";
import c13 from "../assets/c13.jpeg";
import c14 from "../assets/c14.jpeg";
import c15 from "../assets/c15.jpeg";
import c16 from "../assets/c16.jpeg";
import c17 from "../assets/c17.jpeg";
import c18 from "../assets/c18.jpeg";
import c19 from "../assets/c19.jpeg";
import c20 from "../assets/c20.jpeg";
import c21 from "../assets/c21.jpeg";
import c22 from "../assets/c22.jpeg";
import c23 from "../assets/c23.jpeg";
import c24 from "../assets/c24.jpeg";
import c25 from "../assets/c25.jpeg";
import c26 from "../assets/c26.jpeg";
import c27 from "../assets/c27.jpeg";
import c28 from "../assets/c28.jpeg";
import c29 from "../assets/c29.jpeg";
import c30 from "../assets/c30.jpeg";
import c31 from "../assets/c31.jpeg";
import c32 from "../assets/c32.jpeg";
import c33 from "../assets/c33.jpeg"; 
import c34 from "../assets/c34.jpeg"; 
import c35 from "../assets/c35.jpeg"; 
import c36 from "../assets/c36.jpeg"; 
import c37 from "../assets/c37.jpeg"; 
import c38 from "../assets/c38.jpeg"; 
import c39 from "../assets/c39.jpeg"; 
import c40 from "../assets/c40.jpeg"; 
import c41 from "../assets/c41.jpeg"; 
import c42 from "../assets/c42.jpeg"; 
import c43 from "../assets/c43.jpeg"; 
import s12 from "../assets/s12.png";

export const COLLEGES_SYLLABUS_DATA = [
 {
    id: "college-1",
    title: "Web Development",
    hours: "70 hrs",
    image: c1,
    modules: [
      "HTML fundamentals and webpage structure",
      "CSS styling and responsive design",
      "Bootstrap framework and layouts",
      "JavaScript basics and DOM manipulation",
      "Event handling and dynamic scripting",
      "Web gadgets using JavaScript and APIs",
      "Firebase authentication, database, and hosting",
    ],
    outcomes: [
      "Build responsive and interactive websites",
      "Develop dynamic web applications",
      "Use Firebase for authentication and real-time data",
      "Deploy and host websites on cloud platforms",
      "Apply best practices in frontend and backend development",
    ],
  },

  {
    id: "college-2",
    title: "Web App Development with HTML5 & JavaScript",
    hours: "10 hrs",
    image: c2,
    modules: [
      "Canva-style graphics application",
      "Music player app",
      "Simple animation app",
      "Guess the Number game",
      "Dinosaur game",
      "Rock–Paper–Scissors game",
      "Flappy Bird game",
      "Snake game",
      "Whack-a-Mole game",
      "Bouncing Ball animation",
    ],
    outcomes: [
      "Create interactive web apps using HTML5 and JavaScript",
      "Develop browser-based games and animations",
      "Work with canvas, audio, and event handling",
      "Build a mini portfolio of web applications",
    ],
  },

  {
    id: "college-3",
    title: "Full Stack Web Application Using Firebase",
    hours: "50 hrs",
    image: c3,
    modules: [
      "HTML, CSS, and JavaScript basics",
      "Responsive layouts and UI design",
      "JavaScript logic and DOM operations",
      "Firebase authentication and database",
      "CRUD operations and full stack project",
    ],
    outcomes: [
      "Build complete full stack web applications",
      "Implement user authentication and authorization",
      "Manage real-time data using Firebase",
      "Deploy scalable web applications",
    ],
  },

  {
    id: "college-4",
    title: "Web 3.0, Blockchain & NFTs",
    hours: "20 hrs",
    image: c4,
    modules: [
      "Blockchain, cryptocurrency, and Web 3.0 basics",
      "NFT concepts and use cases",
      "Smart contracts using Solidity",
      "Ganache and Truffle framework",
      "MetaMask integration and dApp development",
    ],
    outcomes: [
      "Understand Web 3.0 and blockchain fundamentals",
      "Develop smart contracts and decentralized apps",
      "Integrate blockchain wallets",
      "Build NFT and blockchain-based projects",
    ],
  },

  {
    id: "college-5",
    title: "Game Development",
    hours: "40 hrs",
    image: c5,
    modules: [
      "Unity game engine fundamentals",
      "Game scripting and physics",
      "2D and 3D game development",
      "Game design, testing, and deployment",
    ],
    outcomes: [
      "Develop interactive games using Unity",
      "Apply 2D and 3D game design principles",
      "Implement physics, animations, and UI",
      "Build and publish complete game projects",
    ],
  },

  {
    id: "college-6",
    title: "AR / VR",
    hours: "30 hrs",
    image: c6,
    modules: [
      "Introduction to AR and VR technologies",
      "AR development using Vuforia and AR Foundation",
      "VR UI/UX design and 3D environments",
      "AR/VR integration with AI and ML",
    ],
    outcomes: [
      "Create immersive AR and VR experiences",
      "Develop AR apps for Android and iOS",
      "Design VR environments and interactions",
      "Understand AI integration in AR/VR systems",
    ],
  },

  {
    id: "college-7",
    title: "Python",
    hours: "20 hrs",
    image: c7,
    modules: [
      "Python basics and syntax",
      "Data types, loops, and control structures",
      "Functions and collections",
      "Object-oriented programming",
      "File handling and exception handling",
    ],
    outcomes: [
      "Write efficient Python programs",
      "Apply OOP concepts using Python",
      "Solve real-world programming problems",
      "Build Python-based applications",
    ],
  },

  {
    id: "college-8",
    title: "Java",
    hours: "20 hrs",
    image: c8,
    modules: [
      "Java fundamentals and syntax",
      "Object-oriented programming concepts",
      "Exception and file handling",
      "Multithreading and Swing GUI",
    ],
    outcomes: [
      "Develop Java applications using OOP",
      "Build GUI-based Java programs",
      "Handle exceptions and multithreading",
      "Prepare for advanced Java frameworks",
    ],
  },

  {
    id: "college-9",
    title: "C Programming",
    hours: "20 hrs",
    image: c9,
    modules: [
      "C language fundamentals",
      "Control structures and loops",
      "Arrays, structures, and pointers",
      "File handling and memory management",
    ],
    outcomes: [
      "Understand core programming concepts",
      "Write efficient C programs",
      "Apply pointers and memory management",
      "Solve engineering-oriented problems",
    ],
  },

  {
    id: "college-10",
    title: "C++ Programming",
    hours: "20 hrs",
    image: c10,
    modules: [
      "C++ fundamentals and syntax",
      "Object-oriented programming concepts",
      "STL and templates",
      "Exception and file handling",
    ],
    outcomes: [
      "Develop reusable C++ applications",
      "Apply OOP principles effectively",
      "Use STL for efficient coding",
      "Build real-world C++ projects",
    ],
  },

  {
    id: "college-11",
    title: "Data Structures & Algorithms",
    hours: "20 hrs",
    image: c11,
    modules: [
      "Arrays, stacks, queues, and linked lists",
      "Trees and graphs",
      "Searching and sorting algorithms",
      "Algorithm complexity and optimization",
    ],
    outcomes: [
      "Implement core data structures",
      "Analyze time and space complexity",
      "Solve algorithmic problems efficiently",
      "Prepare for coding interviews",
    ],
  },

  {
    id: "college-12",
    title: "PHP / MySQL",
    hours: "40 hrs",
    image: c12,
    modules: [
      "PHP fundamentals",
      "Form handling and validation",
      "MySQL database design",
      "CRUD operations and backend project",
    ],
    outcomes: [
      "Build dynamic web applications using PHP",
      "Design and manage MySQL databases",
      "Perform secure CRUD operations",
      "Develop server-side web solutions",
    ],
  },

  {
    id: "college-13",
    title: "Machine Learning",
    hours: "20 hrs",
    image: c13,
    modules: [
      "Python basics for ML",
      "NumPy, Pandas, Matplotlib",
      "Supervised and unsupervised learning",
      "Regression and SVM models",
    ],
    outcomes: [
      "Understand machine learning fundamentals",
      "Build ML models using Python",
      "Analyze and preprocess datasets",
      "Apply ML techniques to real-world problems",
    ],
  },

  {
    id: "college-14",
    title: "Deep Learning",
    hours: "20 hrs",
    image: c14,
    modules: [
      "Deep learning fundamentals",
      "Neural networks and architectures",
      "TensorFlow and Keras",
      "Real-world deep learning projects",
    ],
    outcomes: [
      "Understand deep learning concepts",
      "Build neural networks using Python",
      "Apply DL models to real-world data",
      "Work with TensorFlow and Keras",
    ],
  },

  {
    id: "college-15",
    title: "Data Science",
    hours: "20 hrs",
    image: c15,
    modules: [
      "Python fundamentals for data science",
      "NumPy and Pandas",
      "Data visualization with Matplotlib and Seaborn",
      "Machine learning basics and capstone project",
    ],
    outcomes: [
      "Analyze and visualize data effectively",
      "Apply data-driven decision making",
      "Build predictive models",
      "Complete real-world data science projects",
    ],
  },

  {
    id: "college-16",
    title: "Angular",
    hours: "30 hrs",
    image: c16,
    modules: [
      "Angular fundamentals and setup",
      "Components, services, and routing",
      "Forms, validation, and RxJS",
      "Advanced Angular and deployment",
    ],
    outcomes: [
      "Build scalable Angular applications",
      "Implement routing and state management",
      "Consume APIs efficiently",
      "Deploy Angular web applications",
    ],
  },

  {
    id: "college-17",
    title: "React",
    hours: "30 hrs",
    image: c17,
    modules: [
      "React fundamentals and JSX",
      "State management and hooks",
      "Routing and API integration",
      "Advanced React concepts and deployment",
    ],
    outcomes: [
      "Develop modern React applications",
      "Manage state and side effects",
      "Build scalable UI components",
      "Deploy production-ready React apps",
    ],
  },

  {
    id: "college-18",
    title: "Node.js",
    hours: "30 hrs",
    image: c18,
    modules: [
      "Node.js fundamentals",
      "Asynchronous programming",
      "HTTP servers and routing",
      "Backend application development",
    ],
    outcomes: [
      "Build server-side applications using Node.js",
      "Handle asynchronous operations",
      "Develop RESTful APIs",
      "Deploy backend services",
    ],
  },

  {
    id: "college-19",
    title: "Power BI",
    hours: "30 hrs",
    image: c19,
    modules: [
      "Power BI fundamentals",
      "Data modeling and DAX",
      "Data visualization and dashboards",
      "Real-world analytics projects",
    ],
    outcomes: [
      "Create interactive dashboards",
      "Analyze data using DAX",
      "Build business intelligence reports",
      "Support data-driven decisions",
    ],
  },

  {
    id: "college-20",
    title: "UI / UX",
    hours: "30 hrs",
    image: c20,
    modules: [
      "UI/UX fundamentals",
      "Design principles and wireframing",
      "Figma tools and prototyping",
      "Web and app design projects",
    ],
    outcomes: [
      "Design user-centered interfaces",
      "Create wireframes and prototypes",
      "Apply visual design principles",
      "Build professional UI/UX portfolios",
    ],
  },

  {
    id: "college-21",
    title: "MERN Stack Development",
    hours: "20 hrs",
    image: c21,
    modules: [
      "MongoDB database fundamentals",
      "Express and Node.js backend",
      "React frontend integration",
      "Authentication and deployment",
    ],
    outcomes: [
      "Develop full stack MERN applications",
      "Build RESTful APIs",
      "Integrate frontend and backend",
      "Deploy MERN projects",
    ],
  },

  {
    id: "college-22",
    title: "Mastering Excel Essentials",
    hours: "20 hrs",
    image: c22,
    modules: [
      "Excel fundamentals and formatting",
      "Formulas and functions",
      "PivotTables and data analysis",
      "Charts, dashboards, and AI tools",
    ],
    outcomes: [
      "Analyze data using Excel tools",
      "Create reports and dashboards",
      "Use advanced formulas and functions",
      "Apply Excel for business analytics",
    ],
  },

  {
    id: "college-23",
    title: "Web Scraping with Python & BeautifulSoup",
    hours: "20 hrs",
    image: c23,
    modules: [
      "Web scraping fundamentals",
      "Requests and BeautifulSoup",
      "Scraping dynamic content with Selenium",
      "Data storage, automation, and ethics",
    ],
    outcomes: [
      "Extract data from web sources",
      "Scrape static and dynamic websites",
      "Store and analyze scraped data",
      "Build real-world scraping projects",
    ],
  },

    {
  id: "college-24",
  title: "Game Art & Design",
  hours: "30 hrs",
  image: c24,
  modules: [
    "Introduction to game art and design principles",
    "2D asset creation and digital illustration",
    "3D asset modeling fundamentals",
    "Character and environment design",
    "Game UI/UX basics",
    "Game art pipeline and workflows",
    "Portfolio-oriented game art project",
  ],
  outcomes: [
    "Understand the fundamentals of game art and visual storytelling",
    "Create 2D and basic 3D assets for games",
    "Design characters and environments for interactive media",
    "Apply UI/UX principles in game interfaces",
    "Build a beginner-level game art portfolio",
  ],
},

{
  id: "college-25",
  title: "Data Analytics",
  hours: "30 hrs",
  image: c25,
  modules: [
    "Introduction to data analytics and business intelligence",
    "Excel fundamentals and data cleaning techniques",
    "Python for data analysis",
    "Data visualization techniques",
    "Exploratory data analysis (EDA)",
    "Real-world analytics case studies",
    "Analytics capstone project",
  ],
  outcomes: [
    "Understand core concepts of data analytics",
    "Clean, process, and analyze datasets effectively",
    "Use Python and Excel for data-driven insights",
    "Visualize data to support decision-making",
    "Solve real-world problems using analytics techniques",
  ],
},

{
  id: "college-26",
  title: "Prompt Engineering",
  hours: "20 hrs",
  image: c26,
  modules: [
    "Introduction to generative AI and LLMs",
    "Prompt engineering fundamentals",
    "Prompt patterns and optimization techniques",
    "Understanding LLM behavior and limitations",
    "AI tools and workflow automation",
    "Hands-on prompt engineering projects",
  ],
  outcomes: [
    "Understand how large language models work",
    "Design effective prompts for AI applications",
    "Optimize AI responses using prompt patterns",
    "Use AI tools for automation and productivity",
    "Build real-world AI-powered prompt solutions",
  ],
},

{
  id: "college-27",
  title: "Python Django Framework",
  hours: "40 hrs",
  image: c27,
  modules: [
    "Django fundamentals and MVT architecture",
    "Project and app setup",
    "Models, views, and templates",
    "Database integration using ORM",
    "Forms and user input handling",
    "Authentication and admin customization",
    "REST API development",
    "Full-stack Django project",
  ],
  outcomes: [
    "Build complete web applications using Django",
    "Develop database-driven websites with Django ORM",
    "Implement authentication and user authorization",
    "Create RESTful APIs for frontend and mobile apps",
    "Deploy Django applications to production environments",
  ],
},

{
  id: "college-28",
  title: "Python with Flask Server",
  hours: "30 hrs",
  image: c28,
  modules: [
    "Flask framework fundamentals",
    "Project structure and routing",
    "Templates and request handling",
    "Database integration and CRUD operations",
    "Authentication and security basics",
    "REST API development with Flask",
    "Mini backend project",
  ],
  outcomes: [
    "Understand Flask architecture and core concepts",
    "Build lightweight backend web applications",
    "Develop REST APIs using Flask",
    "Connect Flask applications to databases",
    "Deploy Flask-based backend services",
  ],
},

{
  id: "college-29",
  title: "Full Stack Development with Java",
  hours: "50 hrs",
  image: c29,
  modules: [
    "Core Java programming and OOP concepts",
    "Frontend fundamentals",
    "Spring and Hibernate framework",
    "RESTful services development",
    "Database connectivity",
    "End-to-end full stack Java project",
  ],
  outcomes: [
    "Build full stack web applications using Java",
    "Apply object-oriented programming principles",
    "Develop backend services using Spring framework",
    "Integrate frontend and backend systems",
    "Deploy and manage Java-based applications",
  ],
},

{
  id: "college-30",
  title: "FERN / MERN Stack Development",
  hours: "40 hrs",
  image: c30,
  modules: [
    "Frontend development with React",
    "Backend development with Node.js and Express",
    "MongoDB and Firebase integration",
    "Authentication and authorization",
    "REST API integration",
    "Deployment and hosting",
    "Full stack project development",
  ],
  outcomes: [
    "Build responsive frontend applications using React",
    "Develop backend APIs using Node.js and Express",
    "Implement authentication and database integration",
    "Create complete full stack web applications",
    "Deploy production-ready MERN/FERN projects",
  ],
},

{
  id: "college-31",
  title: "Foundations of Flutter Development",
  hours: "30 hrs",
  image: c31,
  modules: [
    "Introduction to mobile app development",
    "Dart programming fundamentals",
    "Flutter widgets and layouts",
    "State management and navigation",
    "User input and form validation",
    "Local data storage",
    "Mini mobile app project",
  ],
  outcomes: [
    "Understand Flutter architecture and Dart basics",
    "Build responsive mobile applications",
    "Implement state management and navigation",
    "Create offline-capable Flutter apps",
    "Develop and publish beginner-level mobile apps",
  ],
},

{
  id: "college-32",
  title: "Spring Boot Framework",
  hours: "30 hrs",
  image: c32,
  modules: [
    "Spring Boot fundamentals",
    "REST API development",
    "Database integration using JPA",
    "Security and JWT authentication",
    "Exception handling and validation",
    "Backend application project",
  ],
  outcomes: [
    "Build backend applications using Spring Boot",
    "Develop RESTful APIs for enterprise systems",
    "Integrate databases with Spring applications",
    "Implement authentication and security features",
    "Deploy scalable backend services",
  ],
},

{
  id: "college-33",
  title: "AWS: Core Services & Management",
  hours: "30 hrs",
  image: c33,
  modules: [
    "Cloud computing fundamentals and AWS overview",
    "AWS account setup and billing management",
    "Core services: EC2, S3, IAM",
    "Databases and networking concepts",
    "Monitoring, deployment, and scaling",
    "Hands-on AWS cloud project",
  ],
  outcomes: [
    "Understand AWS cloud concepts and infrastructure",
    "Deploy and manage applications on AWS",
    "Use EC2, S3, and IAM effectively",
    "Design scalable and cost-effective cloud solutions",
    "Implement basic security and monitoring practices",
  ],
},

{
  id: "college-34",
  title: "Hadoop & Big Data Fundamentals ",
  image: c34,
  modules: [
 "Introduction to Big Data Concepts",
"5Vs of Big Data",
"Hadoop Architecture Overview",
"HDFS Distributed Storage",
"Hadoop Installation & Setup",
"Working with HDFS Commands",
"MapReduce Data Processing",
 "Hadoop Ecosystem Tools",
"Real-World Big Data Use Cases",
"Hands-on Hadoop Mini Activity"
  ],
 
},

{
  id: "college-35",
  title: "Python with Databricks & PySpark",
  image: c35,
  modules: [
"Introduction to Big Data & Databricks",
"Python for Data Engineering",
"Databricks Workspace & Notebooks",
"Apache Spark Fundamentals",
"PySpark DataFrame Operations",
"Data Cleaning & Transformation",
"Working with CSV, JSON & Parquet",
"Data Aggregations & KPI Calculations",
"Spark Integration with Pandas & MLflow",
"Enterprise Data Analytics Mini Project"
  ],
 
},

{
  id: "college-36",
  title: "Generative AI Programming",
  image: c36,
  modules: [
"Fundamentals of Generative AI & LLMs",
"Working with OpenRouter / OpenAI APIs",
"Prompt Engineering Techniques",
"Building AI Chatbots with LLMs",
"Embeddings & Semantic Search",
"Vector Databases (Chroma / FAISS)",
"LangChain Framework for AI Apps",
"Retrieval-Augmented Generation (RAG)",
"Building an AI Knowledge Assistant",
"Deploying Generative AI Applications"
  ],
 
},

{
  id: "college-37",
  title: "Agent AI ",
  image: c37,
  modules: [
"Foundations of Agent AI Concepts",
"Difference between AI, Agent AI & Agentic AI",
"Designing Goal-Driven AI Agents",
"LLM Integration using OpenRouter / OpenAI",
"Decision-Making with Structured Prompts",
"Building Action-Based AI Agents with Python",
"Agent Memory (Short-Term & Long-Term)",
"Integrating Tools, APIs & Databases",
"Error Handling & Safe AI Execution",
"Building an AI Task Automation Agent"
  ],
 
},

{
  id: "college-38",
  title: "Agentic AI",
  image: c38,
  modules: [
"Foundations of Agentic AI Systems",
"Difference between Agent AI & Agentic AI",
"Multi-Agent Architecture Design",
"Planner, Executor & Validator Agents",
"Agent Communication & Collaboration",
"Shared Memory & Context Management",
"Tool Integration with APIs & Databases",
"Human-in-the-Loop AI Governance",
"Building Multi-Agent AI Systems with Python",
"Capstone Project: Enterprise Agentic AI System"
  ],
 
},

{
  id: "college-39",
  title: "API Developer – React & Node.js",
  image: c39,
  modules: [
"Fundamentals of Web APIs & Client–Server Architecture",
"REST API Development using Node.js & Express",
"HTTP Methods (GET, POST, PUT, DELETE)",
"JSON Data Handling & API Responses",
"API Testing using Postman / Hoppscotch",
"React Integration with APIs",
"Dynamic UI Rendering with API Data",
"Search & Filtering with React",
"Frontend–Backend Integration",
"Build a Real API-Based Web Application"
  ],
 
},

{
  id: "college-40",
  title: "API Developer – REST & GraphQL ",
  image: c40,
  modules: [
"API Architecture & Modern Web Applications",
"REST API Development using Node.js",
"GraphQL Fundamentals & Apollo Server",
"MongoDB Database Integration",
"CRUD Operations using REST & GraphQL",
"React Integration with APIs",
"API Testing using Postman & GraphQL Playground",
"Authentication & Error Handling",
"Version Control using Git & GitHub",
"Build a Full Stack API Dashboard "
  ],
 
},

{
  id: "college-41",
  title: "AI Powered Full Stack Developer – MERN",
  image: c41,
  modules: [
"MERN Stack Fundamentals (MongoDB, Express, React, Node)",
"React Frontend Development",
"Backend API Development with Node.js",
"MongoDB Database Management",
"Full Stack Integration (React + Node)",
"Hugging Face AI API Integration",
"OpenRouter AI Chatbot Development",
"AI Features in Web Applications",
"Testing & Version Control with Git",
"Build an AI-Powered MERN Application"
  ],
 
},

{
  id: "college-42",
  title: "Git & GitHub – DevOps Collaboration",
  image: c42,
  modules: [
 "Fundamentals of Version Control Systems",
  "Git Installation & Configuration",
  "Git Commands (add, commit, push, pull)",
  "Branching & Merging Strategies",
  "Merge Conflict Resolution",
  "Working with GitHub Repositories",
  "Pull Requests & Code Reviews",
  "Issue Tracking & Project Boards",
  "CI/CD Workflows using GitHub Actions",
  "Team-Based GitHub Project "
  ],
 
},

{
  id: "college-43",
  title: "Advanced Power BI with SQL & Python",
  image: c43,
  modules: [
"Connecting Power BI with SQL Databases",
"Writing SQL Queries for Data Analysis",
"Data Cleaning using Power Query",
"Data Modeling & Star Schema Design",
"DAX Measures & Calculated Columns",
"Creating Business Dashboards & KPIs",
"Interactive Reports with Filters & Drill-Down",
"Advanced SQL for Business Analytics",
"Python Integration in Power BI",
"Python-Based Data Analysis & Visualizations"
  ],
 
},

 {
    id: "comm-1",
    title: "Communication & Personality Development",
    hours: "30 hrs",
    image: s12,
modules: [
  "Introduction to workplace communication",
  "Product and service communication",
  "Time management and scheduling conversations",
  "Telephone, virtual and remote communication skills",
  "Understanding company structure and operations",
  "Collaboration and teamwork communication",
  "Social and interpersonal workplace communication",
  "Presentation skills and information sharing",
  "Seeking assistance and professional problem-solving",
],
 outcomes: [
  "Communicate confidently in professional and corporate environments",
  "Improve fluency and clarity in workplace English conversations",
  "Handle meetings, calls, and presentations effectively",
  "Strengthen problem-solving and decision-making communication",
  "Build strong professional relationships and networks",
  "Enhance career growth and promotion opportunities",
  "Develop global communication competence for multinational workplaces",
],
idealFor: [
  "Working professionals",
  "Freshers entering corporate roles",
  "Job seekers preparing for interviews",
  "Individuals aiming for career growth",
  "Professionals working in global or client-facing roles",
]
  },

  ];
